function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.1089 0L48.6814 8.25969L63.1207 16.75L63.2539 33.5L63.1207 50.25L48.6814 58.7403L34.1089 67L19.5364 58.7403L5.09704 50.25L4.96389 33.5L5.09704 16.75L19.5364 8.25969L34.1089 0Z",
  fill: "#1E075F"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.588 29.6814L47.2622 28.3556C46.713 27.8064 45.8227 27.8064 45.2735 28.3556L44.9421 28.687L38.3129 22.0579L38.6444 21.7265C39.1936 21.1773 39.1936 20.2869 38.6444 19.7378L37.3186 18.4119C36.7694 17.8627 35.879 17.8627 35.3298 18.4119L28.0378 25.7039C27.4886 26.2531 27.4886 27.1435 28.0378 27.6927L29.3636 29.0184C29.9128 29.5676 30.8032 29.5676 31.3523 29.0184L31.6838 28.687L34.004 31.0072L29.2556 35.7556L28.9241 35.4241C28.1919 34.6919 27.0047 34.6919 26.2724 35.4241L19.5492 42.1475C18.8169 42.8798 18.8169 44.0669 19.5492 44.7992L22.2008 47.4508C22.9331 48.1831 24.1202 48.1831 24.8525 47.4508L31.5758 40.7275C32.3081 39.9953 32.3081 38.8081 31.5758 38.0758L31.2443 37.7444L35.9928 32.996L38.313 35.3161L37.9815 35.6476C37.4323 36.1968 37.4323 37.0872 37.9815 37.6363L39.3073 38.9621C39.8565 39.5113 40.7469 39.5113 41.296 38.9621L48.588 31.6701C49.1372 31.121 49.1372 30.2306 48.588 29.6814Z",
  fill: "white"
});

var SvgGavel = function SvgGavel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGavel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gavel.f6705314.svg";
export { ForwardRef as ReactComponent };